import { render } from "./FaqComp.vue?vue&type=template&id=d5e663ec&scoped=true"
import script from "./FaqComp.vue?vue&type=script&lang=js"
export * from "./FaqComp.vue?vue&type=script&lang=js"

import "./FaqComp.vue?vue&type=style&index=0&id=d5e663ec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e663ec"]])

export default __exports__